// Module
var code = "<with-unison> <div class=\"new-toast cu-justify-content-between cu-align-items-center\"> <div>{{ title }}</div> <cu-icon name=\"close\" ng-click=\"close()\" class=\"close-icon\"></cu-icon> </div> </with-unison> ";
// Exports
module.exports = code;